import { PrimaryButton } from "components/Button/style";
import { ModalCustom } from "components/ModalCustom";
import { useEffect, useState } from "react";
import { FaCheck, FaExclamation } from "react-icons/fa";
import { Corpo, Icone } from "../../components/ModalRetorno/style";
import { IResultadoFinalizacaoSenatran } from "../../interfaces/IAcoesLote";
import { IItemLote } from "../../interfaces/IItemLote";
import {
  algumaFinalizada,
  elegivelParaFinalizarSenatran,
} from "../../utils/finalizarSenatranLote";
import { ContainerBotoes } from "./style";

interface IProps {
  show: boolean;
  handleClose: () => void;
  selecionados: IItemLote[];
  onConfirmar: () => Promise<IResultadoFinalizacaoSenatran | null>;
  carregando: boolean;
}

export function FinalizarSenatranModal({
  show,
  handleClose,
  selecionados,
  onConfirmar,
  carregando,
}: IProps) {
  const [concluido, setConcluido] = useState(false);
  const elegiveis = selecionados.filter(elegivelParaFinalizarSenatran).length;
  const fecharSeLivre = carregando ? () => {} : handleClose;

  useEffect(() => {
    if (show) {
      setConcluido(false);
    }
  }, [show]);

  async function confirmar() {
    const resultado = await onConfirmar();

    if (!resultado) {
      return;
    }

    if (algumaFinalizada(resultado)) {
      setConcluido(true);
    } else {
      handleClose();
    }
  }

  return (
    <ModalCustom
      show={show}
      handleClose={fecharSeLivre}
      title="Finalizar Senatran"
      centered
      footer={!concluido}
      footerTools={
        <ContainerBotoes>
          <PrimaryButton
            type="button"
            outline
            variante="primary"
            onClick={fecharSeLivre}
          >
            Cancelar
          </PrimaryButton>
          <PrimaryButton
            type="button"
            onClick={confirmar}
            disabled={!elegiveis || carregando}
          >
            Finalizar
          </PrimaryButton>
        </ContainerBotoes>
      }
    >
      {concluido ? (
        <Corpo>
          <Icone $tipo="sucesso">
            <FaCheck />
          </Icone>
          Processo finalizado com sucesso!
        </Corpo>
      ) : (
        <Corpo>
          <Icone $tipo="aviso">
            <FaExclamation />
          </Icone>
          Deseja confirmar a finalização do processo no Senatran?
        </Corpo>
      )}
    </ModalCustom>
  );
}
